import React from 'react';
import { Cta1, SubpageBanner } from '../components';
import { useTranslation } from 'react-i18next';

const InvestmentOptions = () => {
    const { t } = useTranslation();

    const dataList = [
        {
            title: t('investmentOptions.staking.title'),
            description: t('investmentOptions.staking.desc'),
            list: [
                { text: t('investmentOptions.staking.l1') },
                { text: t('investmentOptions.staking.l2') },
                { text: t('investmentOptions.staking.l3') },
                { text: t('investmentOptions.staking.l4') },
            ]
        },
        {
            title: t('investmentOptions.futures.title'),
            description: t('investmentOptions.futures.desc'),
            list: [
                { text: t('investmentOptions.futures.l1') },
                { text: t('investmentOptions.futures.l2') },
                { text: t('investmentOptions.futures.l3') },
                { text: t('investmentOptions.futures.l4') },
            ]
        },
        {
            title: t('investmentOptions.spot.title'),
            description: t('investmentOptions.spot.desc'),
            list: [
                { text: t('investmentOptions.spot.l1') },
                { text: t('investmentOptions.spot.l2') },
                { text: t('investmentOptions.spot.l3') },
                { text: t('investmentOptions.spot.l4') },
            ]
        },
        {
            title: t('investmentOptions.copy.title'),
            description: t('investmentOptions.copy.desc'),
            list: [
                { text: t('investmentOptions.copy.l1') },
                { text: t('investmentOptions.copy.l2') },
                { text: t('investmentOptions.copy.l3') },
                { text: t('investmentOptions.copy.l4') },
            ]
        },
        {
            title: t('investmentOptions.ai.title'),
            description: t('investmentOptions.ai.desc'),
            list: [
                { text: t('investmentOptions.ai.l1') },
                { text: t('investmentOptions.ai.l2') },
                { text: t('investmentOptions.ai.l3') },
                { text: t('investmentOptions.ai.l4') },
            ]
        },
        {
            title: t('investmentOptions.wallet.title'),
            description: t('investmentOptions.wallet.desc'),
            list: [
                { text: t('investmentOptions.wallet.l1') },
                { text: t('investmentOptions.wallet.l2') },
                { text: t('investmentOptions.wallet.l3') },
                { text: t('investmentOptions.wallet.l4') },
            ]
        }
    ]
    return (
        <div>
            <SubpageBanner
                title={t('investmentOptions.bannerTitle')}
                page={t('investmentOptions.bannerPage')}
                button={t('investmentOptions.bannerButton')}
                buttonLink="/account"
                path="/investment-options"
            />
            <div className="investment-options">
                <div className="container">
                    <div className="program-features-content">
                        <h2 className="program-features-title">{t('investmentOptions.mainTitle')}</h2>
                        <p className='mt-lg-3 investment-intro-text'>
                            {t('investmentOptions.intro')}
                        </p>
                        <div className="why-join-us mt-lg-5">
                            <div className="why-join-us-content">
                                <div className="investment-options-grid">
                                    {
                                        dataList.map((item, index) => (
                                            <div className="investment-option-item" key={index}>
                                                <div className="investment-option-number">{String(index + 1).padStart(2, '0')}</div>
                                                <h4 className="investment-option-title">{item.title}</h4>
                                                <p className="investment-option-desc">{item.description}</p>
                                                <ul className="investment-option-list">
                                                    {item.list.map((listItem, idx) => (
                                                        <li key={idx}>{listItem.text}</li>
                                                    ))}
                                                </ul>
                                            </div>
                                        ))
                                    }
                                </div>
                            </div>
                        </div>
                        <p className='mt-lg-5 investment-conclusion-text'>
                            {t('investmentOptions.conclusion')}
                        </p>
                    </div>
                </div>
            </div>
            <Cta1
                title={<><span style={{color: '#31cce5' }}>{t('home.ctaInvestment')}</span> {t('home.ctaTitle')}</>}
                subtitle={<span>{t('home.ctaSubtitle')}</span>}
            />
        </div>
    );
};

export default InvestmentOptions;
